import { render, staticRenderFns } from "./wheelBackgroundImagePicker.vue?vue&type=template&id=4cf2a70b&scoped=true"
import script from "./wheelBackgroundImagePicker.vue?vue&type=script&lang=js"
export * from "./wheelBackgroundImagePicker.vue?vue&type=script&lang=js"
import style0 from "./wheelBackgroundImagePicker.vue?vue&type=style&index=0&id=4cf2a70b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2a70b",
  null
  
)

export default component.exports